<template>
  <div class="registrationTradeNo">
    <van-loading size="12vw" text-size="5vw" vertical>{{ message }}</van-loading>
  </div>
</template>

<script>
import {timedPollingOfPaymentStatus} from '@/api/datasyncDataviewsimulator/yinyitong/Payment';

const MAX_CHECK_TIMES = 10;

export default {
  name: 'RegistrationTradeNo',
  data() {
    return {
      message: '支付结果查询中',
      tradeNo: '',
      checkTimes: 0,
      timer: null,
      checking: false
    };
  },
  created() {
    this.tradeNo = this.$route.query.tradeNo || this.$route.query.registrationTradeNo || localStorage.getItem('registrationTradeNo') || '';
    if (!this.tradeNo) {
      this.returnToDoctorDetail('未找到支付订单，请重新选择支付');
      return;
    }
    this.queryPaymentStatus();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    async queryPaymentStatus() {
      if (this.checking) {
        return;
      }
      this.checking = true;
      try {
        const result = await timedPollingOfPaymentStatus({
          serialNumber: this.tradeNo,
          type: 3
        });
        if (result && result.data && result.data.codes == 1) {
          localStorage.removeItem('registrationTradeNo');
          localStorage.removeItem('registrationDraft');
          this.$router.replace({name: 'registrationDetails', query: {isPaymentSuccess: 1}});
          return;
        }

        this.checkTimes += 1;
        if (this.checkTimes >= MAX_CHECK_TIMES) {
          this.returnToDoctorDetail('支付未成功，请重新点击支付');
          return;
        }
        this.timer = setTimeout(() => {
          this.timer = null;
          this.checking = false;
          this.queryPaymentStatus();
        }, 1000);
      } catch (error) {
        console.log('订单状态查询失败=>', error);
        this.returnToDoctorDetail('支付结果查询失败，请重新点击支付');
      } finally {
        if (!this.timer) {
          this.checking = false;
        }
      }
    },

    returnToDoctorDetail(message) {
      this.clearTimer();
      localStorage.removeItem('registrationTradeNo');
      if (message) {
        this.$toast.fail(message);
      }
      const draft = this.getRegistrationDraft();
      if (!draft && !this.$store.state.selectDoctorInfo) {
        this.$router.replace({name: 'outpatientServiceHome'});
        return;
      }
      const appointmentType = draft && draft.appointmentType != null ? draft.appointmentType : 0;
      this.$router.replace({name: 'doctorDetail', query: {appointmentType, paymentFailed: 1}});
    },

    getRegistrationDraft() {
      try {
        return JSON.parse(localStorage.getItem('registrationDraft') || 'null');
      } catch (error) {
        localStorage.removeItem('registrationDraft');
        return null;
      }
    },

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.registrationTradeNo {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
}
</style>
